import { layers } from '@atlaskit/theme/constants';
import { CSM, update } from '@atlassian/customer-service-management-widget-sdk-react';

const belowDialog = layers.dialog() - 1;

type CSMSDKInit = {
	site?: string;
	siteId?: string;
	widgetId?: string;
};

export const initCSM = ({ site: siteProp, siteId, widgetId }: CSMSDKInit): void => {
	let site = siteProp ?? (typeof window !== 'undefined' && window.location.hostname);
	if (!site) {
		return;
	}
	if (site === 'localhost') {
		// if in development and window.location.hostname === 'localhost'
		// we set it to the testing instance's site url. Change if using different one than the one below
		site = 'support-ccp.jira-dev.com';
	}

	CSM({
		site,
		siteId,
		widgetId,
	});

	// Ensures the widget does not render on top of dialogs (e.g., search).
	update({ zIndex: belowDialog });
};
